import React from "react";
import {
	Box,
	FormLabel,
	SimpleGrid,
	Text,
	VStack,
	BoxProps,
} from "@chakra-ui/react";

export const commonInputProps = {
	bg: "#F8F9FA",
	borderRadius: "12px",
	borderColor: "rgba(108, 117, 125, 0.3)",
	height: "48px",
	autoComplete: "off" as const,
	fontSize: "sm",
};

export const commonSelectProps = {
	...commonInputProps,
	// Use native select menu to avoid broken/overlapping menu rendering on mobile/tablet
	native: true as const,
	size: "md" as const,
	borderRadius: "12px",
};

export const sectionCardProps: BoxProps = {
	bg: "white",
	border: "1px solid rgba(108,117,125,0.18)",
	borderRadius: "16px",
	p: { base: 4, md: 5 },
};

export const SectionHeader: React.FC<{ title: string; subtitle?: string }> = ({
	title,
	subtitle,
}) => (
	<Box>
		<Text fontSize="xs" fontWeight="700" color="#6C757D">
			{title}
		</Text>
		{subtitle ? (
			<Text mt={1} fontSize="sm" color="#6C757D">
				{subtitle}
			</Text>
		) : null}
	</Box>
);

export const FieldGrid: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => (
	<SimpleGrid columns={{ base: 1, sm: 1, md: 2 }} spacing={{ base: 3, md: 4 }}>
		{children}
	</SimpleGrid>
);

export const StepContainer: React.FC<{ children: React.ReactNode }> = ({
	children,
}) => (
	<VStack align="stretch" spacing={{ base: 4, md: 6 }}>
		{children}
	</VStack>
);

export const maybeErrorText = (error?: string) =>
	error ? (
		<Text mt={1} fontSize="xs" color="#E53E3E">
			{error}
		</Text>
	) : null;

export const Label: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<FormLabel fontSize="xs" fontWeight="600" color="#6C757D">
		{children}
	</FormLabel>
);
